var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5038 19.9418C19.3751 16.2347 21.8819 15.3112 25.5952 16.4688C31.66 19.1748 37.3634 22.586 42.5798 26.6275C45.6094 28.7997 45.9982 32.4938 42.5798 35.7326C35.7297 40.5323 29.0538 45.1108 24.5228 46.6197C20.7156 47.6993 18.8657 46.4376 18.5038 43.3808C17.8321 35.5814 17.8321 27.7412 18.5038 19.9418Z",
    fill: "#9C9C9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5032 20.9458C21.3746 17.2349 23.8814 16.3105 27.5948 17.4693C33.6594 20.1734 39.3629 23.5838 44.5798 27.6254C47.6094 29.8129 47.9982 33.5108 44.5798 36.7399C37.7295 41.5575 31.0535 46.0887 26.5223 47.6382C22.7151 48.6929 20.8652 47.3908 20.5032 44.3961C19.8323 36.5929 19.8323 28.749 20.5032 20.9458Z",
    fill: "white"
  })));
};

export default __webpack_public_path__ + "static/media/play.f38f5902.svg";
export { SvgPlay as ReactComponent };